import {
  Button,
  Checkbox,
  Inline,
  Modal,
  type ModalProps,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useState } from 'react';

type Props = {
  modalProps: Omit<ModalProps, 'children'>;
  handleCancel: () => void;
  handleConfirm: () => void;
};

export const RequestTerminationModal = ({
  modalProps,
  handleCancel,
  handleConfirm,
}: Props) => {
  const [checked, setChecked] = useState(false);

  return (
    <Modal {...modalProps} span={4}>
      <Modal.Header title="Request termination" onClose={handleCancel} />

      <Modal.Body>
        <Stack>
          <Typography as="span" size="16">
            Given Omnipresent is the legal employer, please{' '}
            <Typography as="span" size="16" weight="bold">
              do not
            </Typography>{' '}
            inform the employee of termination. Instead submit the form on the
            next page and we will support you in a compliant manner.
          </Typography>
          <Checkbox
            id="readTerms"
            label="By ticking, you agree that you have read the above."
            checked={checked}
            onCheckedChange={() =>
              setChecked((previousCheck: boolean) => !previousCheck)
            }
          />
        </Stack>
      </Modal.Body>

      <Modal.Footer>
        <Inline justify="space-between" w="stretch">
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button disabled={!checked} onClick={() => handleConfirm()}>
            Continue
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
